import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InviteUserDialog } from '@estimation/entities/user';
import { Button } from '@shared/ui/Button';
import { useBoolean } from '@conxai/react-kit';
import { AddIcon } from '@shared/ui/icons';
import { useTranslation } from 'react-i18next';
export function InviteUser() {
    const { t } = useTranslation();
    const [isInviteUserDialogOpen, , showInviteUserDialog, hideInviteUserDialog] = useBoolean(false);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", onClick: showInviteUserDialog, startIcon: _jsx(AddIcon, {}), size: "small", children: t('Add user') }), isInviteUserDialogOpen && _jsx(InviteUserDialog, { onClose: hideInviteUserDialog })] }));
}
